/** DEC Energy's legal line: the footers sign with it, `organizationSchema` states it. */
export const COMPANY = { legalName: "DEC Energy SA", email: "info@dec-energy.ch" } as const;
